module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/hikakaku_4a949631d74f7e97eb2616cab52c28eb.png";